import React, { useState } from 'react';
import './Research.css';
import AppBar from "../atoms/AppBar";
import Publication from "./Publication";
import publications from '../../Data/jsons/publications_data.json';
import { FaChartLine, FaAward, FaCode } from 'react-icons/fa';

const Research = () => {
	const [activeTab, setActiveTab] = useState('All');
	const { publicationsData } = publications;

	const handleTabChange = (area) => {
		setActiveTab(area);
	};

	const visiblePublications = publicationsData
		.filter(publication => activeTab === 'All' || publication.area === activeTab)
		.sort((a, b) => b.year - a.year);

	// Calculate statistics
	const totalPublications = publicationsData.length;
	const highlightPapers = publicationsData.filter(pub => pub.awards && pub.awards.includes('Highlight')).length;
	const oralPapers = publicationsData.filter(pub => pub.awards && pub.awards.includes('Oral')).length;

	const renderPublications = () => {
		let lastYear = null;
		return visiblePublications.map((publication, index) => {
			const showYear = publication.year !== lastYear;
			lastYear = publication.year;
			return (
				<React.Fragment key={index}>
					{showYear && (
						<div className="timeline-year-marker">
							<span>{publication.year}</span>
						</div>
					)}
					<Publication
						title={publication.title}
						authors={publication.authors}
						conference={publication.conference}
						year={publication.year}
						imageUrl={publication.imageUrl}
						bibtex={publication.bibtex}
						acceptanceRate={publication.acceptanceRate}
						awards={publication.awards}
						video={publication.video}
						slides={publication.slides}
						poster={publication.poster}
						arxivLink={publication.arxivLink}
						projectLink={publication.projectLink}
						otherVersions={publication.otherVersions}
					/>
				</React.Fragment>
			);
		});
	};

	return (
		<div className="home-container research-page">
			<AppBar />

			<div className="research-main-content">
				{/* Header Section */}
				<header className="research-header">
					<div className="hero-text">
						<h1 className="hero-title">Research <em>&</em> Publications</h1>
						<p className="hero-subtitle">
							Focusing on Multi-Modal Scene Understanding.
						</p>
					</div>

					{/* Stats integrated like hero-image/news area */}
					<div className="research-stats">
						<div className="stat-item">
							<div className="stat-icon"><FaChartLine size={24} /></div>
							<div className="stat-text">
								<span className="stat-val">{totalPublications}</span>
								<span className="stat-lab">Publications</span>
							</div>
						</div>
						<div className="stat-item">
							<div className="stat-icon"><FaCode size={24} /></div>
							<div className="stat-text">
								<span className="stat-val">{oralPapers}</span>
								<span className="stat-lab">Orals</span>
							</div>
						</div>
						<div className="stat-item">
							<div className="stat-icon"><FaAward size={24} /></div>
							<div className="stat-text">
								<span className="stat-val">{highlightPapers}</span>
								<span className="stat-lab">Highlights</span>
							</div>
						</div>
					</div>
				</header>

				{/* Filters Section - Sticky like News Heading */}
				<div className="filters-bar">
					<div className="filter-tabs">
						{['All', 'Scene Understanding', 'Robotics', 'Robust Learning'].map(area => (
							<button
								key={area}
								className={`filter-tab ${activeTab === area ? 'active' : ''}`}
								onClick={() => handleTabChange(area)}
							>
								{area}
								{area !== 'All' && (
									<span className="tab-count">
										{publicationsData.filter(pub => pub.area === area).length}
									</span>
								)}
							</button>
						))}
					</div>
				</div>

				{/* Publications List */}
				<section className="publications-list-section">
					<div className="publications-list">
						{renderPublications()}
					</div>
				</section>
			</div>
		</div>
	);
}

export default Research;
